import React, { useState, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  noticeModifyStateRecoil,
} from '../../atom/ModalAtom';
import { roomIdStateRecoil } from '../../atom/RoomAtom';
import { userIdState } from '../../atom/TokenAtom';
import { socketio } from '../../api/socket.api';
import eventbus from '../../api/eventbus';
import { roomAPI } from '../../api/axiosIndex';
import { Icon } from '../../component/Icon';

interface NoticeModifyProps {
  roomId: number;
  roomNotice: string | undefined;
  onListUpdate: () => void;
}

const NoticeModify = ({
  roomId,
  roomNotice,
  onListUpdate,
}: NoticeModifyProps) => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const [userId, setUserId] = useRecoilState(userIdState);

  const navigate = useNavigate();

  const setModalState = useSetRecoilState(noticeModifyStateRecoil);
  const setRoomIdState = useSetRecoilState(roomIdStateRecoil);

  const [noticeText, setNoticeText] = useState(roomNotice);

  const handleConfirm = async () => {
    try {
      await roomAPI.putNotice(roomId, String(noticeText));
      socketio.noticeUpdate(Number(roomId));
      setModalState(false);
      onListUpdate();
    } catch {
      setError('공지사항 수정에 실패하였습니다.');
    }
  };

  return (
    <>
      <InputModal
        title="공지사항"
        onCancel={() => setModalState(false)}
        onConfirm={handleConfirm}
      >
        <ul className="input-wrap">
          <li>
            <h2>
              내용
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <TextWrap>
              <CS.TextAreaType1
                placeholder="내용 입력"
                value={noticeText}
                onChange={(e) => setNoticeText(e.target.value)}
              />
              <button className="img-box" onClick={() => setNoticeText('')}>
                <Icon name="ResetIcon" size="100%" color="#435699" />
              </button>
            </TextWrap>
          </li>
        </ul>
      </InputModal>
    </>
  );
};

export default NoticeModify;

const TextWrap = styled.div`
  width: 100%;
  position: relative;
  > textarea {
    padding-right: 32px;
  }
  > button {
    width: 20px;
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
  }
`;
